import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { MyContext } from "../../../MyContextApi";

import "../../../styles/NavBar.css";
import csmartLogo from "../../../images/csmart-white.png";

import AvatarDropdown from "./DropDown";
import NavigationTabs from "./NavigationTabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarsStaggered, faBars } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";

function NavBar({ setIsLoggedIn, setUserDetails }) {
  const location = useLocation();
  const { toggleButton, collapsed, setCollapsed } = useContext(MyContext);

  const tabConfigurations = [
    {
      routes: ["/socialMediaCrawler", "/crawledImage","/audioAnalysis"],
      labels: ["On Demand Crawler", "Image Analysis", "Audio Analysis"],
      defaultRoute: "/socialMediaCrawler",
    },
    {
      routes: ["/fakeNews", "/factChecker", "/newsSentiment"],
      labels: ["Fake News", "Fact Checker", "News Sentiment"],
      defaultRoute: "/fakeNews",
    },
    {
      routes: ["/reportgen", "/downloadHistory"],
      labels: ["Generate Report", "Download History"],
      defaultRoute: "/reportgen",
    },
    {
      routes: ["/dashboard"],
      labels: ["Highlights"],
      defaultRoute: "/dashboard",
    },
  ];

  const crawlerRoutes = [
    "/socialMediaCrawler",
    "/newsSentiment",
    "/crawledImage",
    "/audioAnalysis",
    "/dashboard",
    "/dashboardSentiment",
    "/dashboardSection",
    "/fakeNews",
    "/factChecker",
    "/reportgen",
    "/downloadHistory",
    "/TASKS",
  ];

  // Check if the current route matches any of the crawler routes
  const isCrawlerRoute = crawlerRoutes.includes(location.pathname);

  return (
    <nav className={`navbar ${toggleButton ? "show" : "hide"}`}>
      <Button
        onClick={() => setCollapsed(!collapsed)}
        sx={{
          borderRadius: "50%",
          minWidth: "40px",
          minHeight: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            transform: "scale(1.1)",
          },
        }}
      >
        <FontAwesomeIcon
          icon={collapsed ? faBarsStaggered : faBars}
          style={{
            color: "white",
            opacity: 0.85,
            fontSize: "23px",
            transition: "color 0.3s, opacity 0.3s",
          }}
        />
      </Button>

      <div className="navbar__left">
        <h1 className="app-title">
          <img src={csmartLogo} alt="C-SMART" className="app-title__logo" />
        </h1>
      </div>

      <div className="navbar__center">
        {isCrawlerRoute && <NavigationTabs tabConfig={tabConfigurations} />}
      </div>

      <div className="navbar__right">
        <AvatarDropdown
          setIsLoggedIn={setIsLoggedIn}
          setUserDetails={setUserDetails}
        />
      </div>
    </nav>
  );
}

export default NavBar;
